import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain"

export default [
    "PFPF",
    "PFF",
    "HF"
];

// Locales for which flight packages are enabled (UK and NL websites).
// www.benl.yoonly.eu sells the same flight packages (PFF, PFPF, HF).
// www.befr.yoonly.eu is train only.
export const flightEnabledLocales = ["en_US", "nl_NL"];

const flightEnabledDomains = ["www.benl.yoonly.eu"];

export const isFlightEnabledLocale = (locale: string): boolean => {
    if (flightEnabledLocales.includes(locale?.replace("-", "_"))) return true
    const hostname = typeof window !== "undefined" ? window.location.hostname : ""
    return flightEnabledDomains.includes(getSiteFromDomain(hostname))
}
